import { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Trash2, ChevronDown, ChevronUp, Pencil, Check, X } from 'lucide-react';

function fmt(v) {
  if (v === null || v === undefined || v === '') return '';
  var n = Number(v);
  if (isNaN(n)) return '';
  return n.toFixed(4).replace(/\.?0+$/, '');
}

export function TariffRow({ row, onChange, onDelete }) {
  var [expanded, setExpanded] = useState(false);
  var [editing, setEditing] = useState(false);
  var [draft, setDraft] = useState({});

  var startEdit = function () {
    setDraft({
      tariff_code: row.tariff_code || '',
      tariff_name: row.tariff_name || '',
      tariff_type: row.tariff_type || 'flat',
      network_distributor: row.network_distributor || '',
      supply_charge_daily: row.supply_charge_daily || '',
      usage_rate_flat: row.usage_rate_flat || '',
      usage_rate_peak: row.usage_rate_peak || '',
      usage_rate_peak_2: row.usage_rate_peak_2 || '',
      usage_rate_shoulder: row.usage_rate_shoulder || '',
      usage_rate_off_peak: row.usage_rate_off_peak || '',
      controlled_load_rate: row.controlled_load_rate || '',
      controlled_load_rate_2: row.controlled_load_rate_2 || '',
      demand_rate: row.demand_rate || '',
      demand_rate_2: row.demand_rate_2 || '',
      peak_hours: row.peak_hours || '',
    });
    setEditing(true);
  };

  var saveEdit = function () {
    Object.keys(draft).forEach(function (k) {
      var v = draft[k];
      if (['supply_charge_daily', 'usage_rate_flat', 'usage_rate_peak', 'usage_rate_peak_2', 'usage_rate_shoulder', 'usage_rate_off_peak', 'controlled_load_rate', 'controlled_load_rate_2', 'demand_rate', 'demand_rate_2'].indexOf(k) >= 0) {
        v = v === '' ? null : parseFloat(v) || null;
      }
      onChange(k, v);
    });
    setEditing(false);
  };

  var cancelEdit = function () { setEditing(false); };

  var typeBadge = row.tariff_type === 'tou'
    ? 'bg-blue-50 text-blue-700 border-blue-200'
    : row.tariff_type === 'demand'
      ? 'bg-orange-50 text-orange-700 border-orange-200'
      : 'bg-slate-50 text-slate-600 border-slate-200';

  var typeLabel = row.tariff_type === 'tou' ? 'TOU' : row.tariff_type === 'demand' ? 'Demand' : 'Flat';

  if (editing) {
    return (
      <>
        <tr className="border-b border-slate-200 bg-blue-50/40" data-testid={'tariff-edit-' + row.tariff_code}>
          <td className="px-2 py-1"><input value={draft.tariff_code} onChange={function (e) { setDraft({ ...draft, tariff_code: e.target.value }); }} className="w-16 text-[11px] font-mono border rounded px-1 py-0.5" /></td>
          <td className="px-2 py-1"><input value={draft.tariff_name} onChange={function (e) { setDraft({ ...draft, tariff_name: e.target.value }); }} className="w-32 text-[11px] border rounded px-1 py-0.5" /></td>
          <td className="px-2 py-1">
            <select value={draft.tariff_type} onChange={function (e) { setDraft({ ...draft, tariff_type: e.target.value }); }} className="text-[11px] border rounded px-1 py-0.5">
              <option value="flat">Flat</option><option value="tou">TOU</option><option value="demand">Demand</option>
            </select>
          </td>
          <td className="px-2 py-1"><input value={draft.network_distributor} onChange={function (e) { setDraft({ ...draft, network_distributor: e.target.value }); }} className="w-20 text-[11px] border rounded px-1 py-0.5" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.0001" value={draft.supply_charge_daily} onChange={function (e) { setDraft({ ...draft, supply_charge_daily: e.target.value }); }} className="w-16 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.0001" value={draft.usage_rate_flat} onChange={function (e) { setDraft({ ...draft, usage_rate_flat: e.target.value }); }} className="w-14 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.0001" value={draft.usage_rate_peak} onChange={function (e) { setDraft({ ...draft, usage_rate_peak: e.target.value }); }} className="w-14 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.0001" value={draft.usage_rate_shoulder} onChange={function (e) { setDraft({ ...draft, usage_rate_shoulder: e.target.value }); }} className="w-14 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.0001" value={draft.usage_rate_off_peak} onChange={function (e) { setDraft({ ...draft, usage_rate_off_peak: e.target.value }); }} className="w-14 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.0001" value={draft.controlled_load_rate} onChange={function (e) { setDraft({ ...draft, controlled_load_rate: e.target.value }); }} className="w-14 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right"><input type="number" step="0.01" value={draft.demand_rate} onChange={function (e) { setDraft({ ...draft, demand_rate: e.target.value }); }} className="w-14 text-[11px] border rounded px-1 py-0.5 text-right" /></td>
          <td className="px-2 py-1 text-right">
            <div className="flex gap-1 justify-end">
              <button onClick={saveEdit} className="text-green-600 hover:text-green-800 p-0.5" title="Save"><Check className="w-3.5 h-3.5" /></button>
              <button onClick={cancelEdit} className="text-slate-400 hover:text-slate-600 p-0.5" title="Cancel"><X className="w-3.5 h-3.5" /></button>
            </div>
          </td>
        </tr>
      </>
    );
  }

  return (
    <>
      <tr className={'border-b border-slate-100 hover:bg-slate-50/70 cursor-pointer text-[11px]'} onClick={function () { setExpanded(!expanded); }} data-testid={'tariff-row-' + row.tariff_code}>
        <td className="px-2 py-1.5 font-mono text-slate-800 whitespace-nowrap">{row.tariff_code}</td>
        <td className="px-2 py-1.5 text-slate-700 max-w-[160px] truncate" title={row.tariff_name}>{row.tariff_name}</td>
        <td className="px-2 py-1.5"><span className={'px-1.5 py-0.5 rounded text-[10px] font-medium border ' + typeBadge}>{typeLabel}</span></td>
        <td className="px-2 py-1.5 text-slate-600 whitespace-nowrap">{row.network_distributor}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-800">{fmt(row.supply_charge_daily)}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-600">{fmt(row.usage_rate_flat)}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-600">{fmt(row.usage_rate_peak)}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-600">{fmt(row.usage_rate_shoulder)}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-600">{fmt(row.usage_rate_off_peak)}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-600">{fmt(row.controlled_load_rate)}</td>
        <td className="px-2 py-1.5 text-right font-mono text-slate-600">{fmt(row.demand_rate)}</td>
        <td className="px-2 py-1.5 text-right">
          <div className="flex gap-0.5 justify-end" onClick={function (e) { e.stopPropagation(); }}>
            <button onClick={startEdit} className="text-slate-400 hover:text-blue-600 p-0.5" title="Edit"><Pencil className="w-3 h-3" /></button>
            <button onClick={onDelete} className="text-slate-400 hover:text-red-600 p-0.5" title="Delete"><Trash2 className="w-3 h-3" /></button>
            <button onClick={function () { setExpanded(!expanded); }} className="text-slate-400 hover:text-slate-600 p-0.5">
              {expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
            </button>
          </div>
        </td>
      </tr>
      {expanded && (
        <tr className="border-b border-slate-100 bg-slate-50/50">
          <td colSpan={12} className="px-3 py-2">
            <div className="text-[11px] text-slate-600 space-y-1">
              {row.description && <p className="text-slate-700">{row.description}</p>}
              <div className="flex flex-wrap gap-x-4 gap-y-0.5">
                {row.usage_rate_peak_2 ? <span>Peak 2: <b>{fmt(row.usage_rate_peak_2)}</b> $/kWh</span> : null}
                {row.step_height ? <span>Step: <b>{row.step_height}</b> kWh</span> : null}
                {row.controlled_load_rate_2 ? <span>CL2: <b>{fmt(row.controlled_load_rate_2)}</b></span> : null}
                {row.demand_rate_2 ? <span>Demand 2: <b>{fmt(row.demand_rate_2)}</b></span> : null}
                {row.demand_unit ? <span>Demand unit: <b>{row.demand_unit}</b></span> : null}
                {row.price_plan_code ? <span className="text-slate-400">Plan: {row.price_plan_code}</span> : null}
                {row.tco_code ? <span className="text-slate-400">TCO: {row.tco_code}</span> : null}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
